import { createFileRoute } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { TypeSignaturePage } from "@/tools/signature-maker/pages/TypeSignaturePage";

const PATH = "/signature-maker/type";

export const Route = createFileRoute("/signature-maker/type")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.sig_type_meta_title() },
      { name: "description", content: m.sig_type_meta_description() },
      { property: "og:title", content: m.sig_type_meta_title() },
      { property: "og:description", content: m.sig_type_meta_description() },
      ...i18nOgMeta(PATH),
    ],
    links: [...i18nLinks(PATH)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.sig_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.sig_tool_name(),
              item: localeUrl(`/signature-maker`),
            },
            {
              "@type": "ListItem",
              position: 3,
              name: m.sig_nav_type(),
              item: localeUrl(`${PATH}`),
            },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: m.sig_type_faq1_q(),
              acceptedAnswer: { "@type": "Answer", text: m.sig_type_faq1_a() },
            },
            {
              "@type": "Question",
              name: m.sig_type_faq2_q(),
              acceptedAnswer: { "@type": "Answer", text: m.sig_type_faq2_a() },
            },
          ],
        }),
      },
    ],
  }),
  component: TypeSignaturePage,
});
